import React, { useState, useRef, useEffect } from 'react';
import CommunityInfoModal from './CommunityInfoModal';
import './CommunitySelect.css';

const CommunitySelect = ({ communities = [], value, onChange, placeholder = 'Select a community...', loading = false, onOpen = null, displayTitle = '' }) => {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('');
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtered = communities.filter(c =>
    c.name.toLowerCase().includes(filter.toLowerCase()) ||
    c.title.toLowerCase().includes(filter.toLowerCase())
  );

  const handleSelect = (name) => {
    onChange(name);
    setOpen(false);
    setFilter('');
  };

  const selectedObj = communities.find(c => c.name === value);
  const display = selectedObj ? selectedObj.title : (value ? (displayTitle || value) : placeholder);
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    // hide info modal when selection changes
    setShowInfo(false);
  }, [value]);

  return (
    <div className="community-select-container" ref={containerRef}>
      <div className="community-select-display" onClick={() => {
          const willOpen = !open;
          setOpen(willOpen);
          if (willOpen && typeof onOpen === 'function') {
            onOpen();
          }
        }}>
        {display}
        <span className="arrow">▾</span>
      </div>
      <span
        className={`community-info-icon ${selectedObj ? '' : 'disabled'}`}
        title={selectedObj ? 'Community info' : ''}
        onClick={selectedObj ? () => setShowInfo(true) : null}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <circle cx="12" cy="8" r="1"></circle>
        </svg>
      </span>
      {open && (
        <div className="community-dropdown">
          <input
            type="text"
            className="community-filter"
            placeholder="Search..."
            value={filter}
            onChange={e => setFilter(e.target.value)}
            autoFocus
          />
          <div className="community-options">
            {loading && <div className="community-option loading">Loading...</div>}
            {!loading && filtered.map(c => (
              <div
                key={c.name}
                className="community-option"
                onClick={() => handleSelect(c.name)}
              >
                c/{c.name} - {c.title}
              </div>
            ))}
            {!loading && filtered.length === 0 && <div className="community-option empty">No matches</div>}
          </div>
        </div>
      )}
      {showInfo && selectedObj && (
        <CommunityInfoModal community={selectedObj} onClose={() => setShowInfo(false)} />
      )}
    </div>
  );
};

export default CommunitySelect;
